/* eslint-disable react/prop-types */
import { formatDate } from '@jd/jmtd-tools/es/date';
import Button from '@jd/jmtd/es/Button';
import Icon from '@jd/jmtd/es/Icon';
import Tag from '@jd/jmtd/es/Tag';
import Text from '@jd/jmtd/es/Text';
import React from 'react';
export default function (_ref, _ref2) {
  var disabled = _ref.disabled,
      refresh = _ref.refresh,
      getCountdown = _ref.getCountdown;
  var _ref2$timeFormatter = _ref2.timeFormatter,
      timeFormatter = _ref2$timeFormatter === void 0 ? 'YYYY-MM-DD hh:mm:ss' : _ref2$timeFormatter,
      value = _ref2.value;
  return /*#__PURE__*/React.createElement("span", {
    className: "jmtp-ge-realtime"
  }, /*#__PURE__*/React.createElement(Text, null, "\u65F6\u95F4\uFF1A", formatDate(value, timeFormatter)), disabled ? /*#__PURE__*/React.createElement(Tag, {
    className: "jmtp-ge-realtime-countdown-tag"
  }, getCountdown()) : /*#__PURE__*/React.createElement(Button, {
    link: true,
    startIcon: /*#__PURE__*/React.createElement(Icon, {
      className: "jmti-refresh"
    }),
    semantic: "primary",
    onClick: refresh
  }));
}